import { BaseApi } from "./base.api";
import { TTemplateMergeTagGroup } from "../types/template-merge-tag.type";

export class AccountUrlSyncApi extends BaseApi {
  async fetchMergeTags(accountId: number): Promise<TTemplateMergeTagGroup[]> {
    return this.get(`/accounts/${accountId}/url-sync/merge-tags`);
  }
}
